<template>
  <div class="membership-page fade-in">
    <!-- ===== Header Section ===== -->
    <div class="plans-header">
      <h2>Choose the Perfect Plan for Your Business</h2>
      <p>
        Scale your operations with flexible membership plans built to match your growth.
        Upgrade anytime — unlock premium analytics, automation, and more.
      </p>
      <div class="cta-actions">
        <button class="btn-primary"><i class="bx bx-rocket"></i> Get Started</button>
        <button class="btn-secondary"><i class="bx bx-help-circle"></i> Learn More</button>
      </div>
    </div>

    <!-- ===== Loader ===== -->
    <transition name="fade-slide">
      <div v-if="loading" class="global-loader">
        <div class="loader-spinner"></div>
        <p>Loading...</p>
      </div>
    </transition>

    <!-- ===== Plans Cards Section ===== -->
    <div class="plans-container">
      <div
        v-for="(plan, i) in plans"
        :key="i"
        :class="['plan-card', { featured: plan.featured }]"
      >
        <!-- Icon + Plan Name -->
        <div class="plan-header">
          <i :class="plan.icon"></i>
          <h3>{{ plan.plan_title || plan.name }}</h3>
          <p class="plan-subtitle" v-if="plan.featured">Most Popular</p>
        </div>

        <!-- Price Section -->
        <div class="plan-price">
          <h2>{{ plan.plan_price || plan.price }}</h2>
          <span class="duration">/ {{ plan.plan_duration || plan.duration }}</span>
        </div>

        <!-- Features List -->
        <ul class="plan-features">
          <li v-for="(feat, j) in plan.frt || plan.features" :key="j">
            <i class="bx bx-check-circle"></i> {{ feat }}
          </li>
        </ul>

        <!-- Action Button -->
        <button
          :disabled="plan.my_plan === 1"
          :class="plan.my_plan === 1 ? 'btn-disabled wide-btn' : plan.featured ? 'btn-primary wide-btn' : 'btn-secondary wide-btn'"
          @click="plan.my_plan === 1 ? null : openUpgradePopup(plan)"
        >
          <i v-if="plan.my_plan === 1" class="bx bx-check-shield"></i>
          <i v-else class="bx bx-upvote"></i>
          {{ plan.my_plan === 1 ? 'Current Plan (' + remainingDays() + ' days left)' : 'Upgrade Plan' }}
        </button>
      </div>
    </div>

    <!-- ===== Upgrade Popup ===== -->
<div v-if="showPaymentPopup" class="payment-popup-overlay" @click.self="closePopup">
  <div class="payment-popup">
    <h3>Choose Your Payment Gateway</h3>
    <p>Securely upgrade your plan using your preferred payment method.</p>
    <div class="gateway-options">
      <div class="gateway razorpay" @click="selectGateway('razorpay')">
        <i class="bx bx-credit-card gateway-icon razorpay-icon"></i>
        <span>Razorpay</span>
      </div>
      <div class="gateway paypal" @click="selectGateway('paypal')">
        <i class="bx bxl-paypal gateway-icon"></i>
        <span>PayPal</span>
      </div>
      <div class="gateway stripe" @click="selectGateway('stripe')">
        <i class="bx bxl-stripe gateway-icon"></i>
        <span>Stripe</span>
      </div>
    </div>
    <button class="btn-secondary close-btn" @click="closePopup">Cancel</button>
  </div>
</div>

  </div>
  <br><br><br>
</template>

<script>
import { getPlanList } from "@/apis/planapi";
import { apiBaseUrl } from "@/apis/appconst";

export default {
  name: "MembershipPlans",
  data() {
    return {
      plans: [],
      user: {},
      loading: false,
      showPaymentPopup: false,
      selectedPlan: null,
    };
  },
  methods: {
    async fetchPlans() {
      try {
        this.loading = true;
        const userData = JSON.parse(sessionStorage.getItem("ldata"));
        this.user = userData || {};

        const res = await getPlanList(this.user.user_id);

        if (res.status && res.records) {
          // ✅ Normalize each plan and parse plan_features if it's a string
          this.plans = res.records.map((plan, index) => {
            let parsedFeatures = [];

            try {
              if (typeof plan.plan_features === "string") {
                parsedFeatures = JSON.parse(plan.plan_features);
              } else if (Array.isArray(plan.plan_features)) {
                parsedFeatures = plan.plan_features;
              }
            } catch (e) {
              console.warn("Invalid JSON in plan_features:", plan.plan_features);
            }

            return {
              ...plan,
              frt: parsedFeatures,
              // Keep "middle plan" highlighted (featured = true)
              featured: index === 1, // 0=first, 1=middle, 2=last
            };
          });
        } else {
          this.$toast?.error(res.success || "Failed to load plans");
        }
      } catch (err) {
        console.error("fetchPlans error:", err);
        this.$toast?.error("Something went wrong");
      } finally {
        this.loading = false;
      }
    },

    remainingDays() {
      if (!this.user.user_plan_expiry) return "∞";
      const today = new Date();
      const expiry = new Date(this.user.user_plan_expiry);
      const diff = Math.ceil((expiry - today) / (1000 * 60 * 60 * 24));
      return diff > 0 ? diff : 0;
    },

    openUpgradePopup(plan) {
      this.selectedPlan = plan;
      this.showPaymentPopup = true;
    },
    closePopup() {
      this.showPaymentPopup = false;
      this.selectedPlan = null;
    },
    async selectGateway(gateway) {
      var payUrl = "razorpay/redirectToPaymentGateway";
      if((gateway+"").localeCompare("paypal")==0){
        payUrl = "paypal/redirectToPaymentGateway";
      }
      else if((gateway+"").localeCompare("stripe")==0){
        payUrl = "stripe/redirectToPaymentGateway";
      }
      const user = JSON.parse(sessionStorage.getItem("ldata"));
      payUrl = apiBaseUrl+payUrl+"?rtype=mem&amount="+this.selectedPlan.plan_id+"&curr=USD&uid="+user.user_id;

      window.location.href = payUrl;
    

      // this.showPaymentPopup = false;
      // this.$toast?.success(`Redirecting to ${gateway} for payment...`);
      // this.loading = true;
      // const user = JSON.parse(sessionStorage.getItem("ldata"));
      // const res = await updateUserPlan(user.user_id, this.selectedPlan.plan_id);
      // this.loading = false;
      // if (res.status) {
      //   this.$toast?.success(res.success || "Plan updated successfully");

      //   user.user_plan_name = res.plan?.plan_title || "";
      //   user.user_plan_expiry = res.expiry;
      //   sessionStorage.setItem("ldata", JSON.stringify(user));

      //   this.fetchPlans();
      // } else {
      //   this.$toast?.error(res.success || "Failed to update plan");
      // }
      
    },
  },
  mounted() {
    this.fetchPlans();
    if ((window.location.href + "").includes("udata")) {
      const udata = this.$route.query.udata;
      if(udata!=null && udata!=undefined && udata.length>0){
        const ldata = JSON.parse(atob(udata));
        if(ldata!=null && ldata!=undefined){
          if(ldata.type.localeCompare("danger")==0){
            this.$toast?.error(ldata.msg);
          }
          else {
            this.$toast?.success(ldata.msg);
            window.location.reload();
          }
        }
      }
    }
  },
};
</script>



<style scoped>
/* === Animations === */
.fade-in {
  animation: fadeInUp 0.6s ease forwards;
  opacity: 0;
  transform: translateY(10px);
}
@keyframes fadeInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* === Header Section === */
.plans-header {
  text-align: center;
  margin-bottom: 2.5rem;
  color: var(--text);
  max-width: 700px;
  margin-inline: auto;
}
.plans-header h2 {
  font-size: 1.8rem;
  font-weight: 700;
  color: #111827;
}
.plans-header p {
  color: #6b7280;
  margin: 0.5rem 0 1.5rem;
  line-height: 1.6;
}
.cta-actions {
  display: flex;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
}

/* === Plans Container === */
.plans-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 24px;
  justify-content: center;
  align-items: stretch;
}

/* === Plan Card === */
.plan-card {
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 14px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.05);
  padding: 2rem 1.5rem;
  text-align: center;
  transition: all 0.35s ease;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.plan-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}

/* === Featured Card === */
.plan-card.featured {
  border: 2px solid var(--primary);
  background: linear-gradient(135deg, #111827, #1e3a8a);
  color: #fff;
  transform: scale(1.04);
}
.plan-card.featured h3,
.plan-card.featured .duration,
.plan-card.featured .plan-features li {
  color: #fff;
}
.plan-card.featured .bx-check-circle {
  color: #dbeafe;
}
.plan-card.featured .btn-primary {
  background: #fff;
  color: #111827;
}

/* === Plan Header === */
.plan-header {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.plan-header i {
  font-size: 2rem;
  color: var(--primary);
  margin-bottom: 10px;
}
.plan-card.featured i {
  color: #fff;
}
.plan-header h3 {
  font-size: 1.3rem;
  font-weight: 700;
}
.plan-subtitle {
  font-size: 0.9rem;
  background: #facc15;
  color: #111827;
  padding: 4px 10px;
  border-radius: 999px;
  margin-top: 6px;
  font-weight: 600;
}

/* === Price Section === */
.plan-price {
  margin: 1rem 0;
}
.plan-price h2 {
  font-size: 2rem;
  font-weight: 700;
  color: var(--primary);
}
.plan-card.featured .plan-price h2 {
  color: #fff;
}
.duration {
  color: #6b7280;
  font-size: 0.9rem;
}

/* === Features === */
.plan-features {
  list-style: none;
  text-align: left;
  padding: 0;
  margin: 1.5rem 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.plan-features li {
  font-size: 0.95rem;
  color: #374151;
  display: flex;
  align-items: center;
  gap: 8px;
}
.plan-card.featured .plan-features li {
  color: #e5e7eb;
}

/* === Buttons === */
.btn-primary,
.btn-secondary {
  border: none;
  padding: 10px 18px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.btn-primary {
  background: var(--primary, #111827);
  color: #fff;
}
.btn-secondary {
  background: #f3f4f6;
  color: #111827;
}
.btn-primary:hover {
  background: #1e3a8a;
}
.btn-secondary:hover {
  background: #e5e7eb;
}
.wide-btn {
  width: 100%;
  margin-top: 1rem;
  padding: 12px;
  font-size: 15px;
}

/* === Responsive === */
@media (max-width: 768px) {
  .plans-header h2 {
    font-size: 1.5rem;
  }
  .plan-card {
    padding: 1.5rem;
  }
}

/* === Disabled Button State === */
.btn-disabled {

   border: none;
  padding: 10px 18px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

/* === Payment Popup Overlay === */
.payment-popup-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

/* === Payment Popup Box === */
.payment-popup {
  background: #fff;
  border-radius: 14px;
  padding: 2rem;
  width: 90%;
  max-width: 420px;
  text-align: center;
  animation: fadeInUp 0.3s ease forwards;
}
.payment-popup h3 {
  margin-bottom: 0.5rem;
  font-weight: 700;
  color: #111827;
}
.payment-popup p {
  font-size: 0.9rem;
  color: #6b7280;
  margin-bottom: 1.5rem;
}

/* === Gateway Buttons === */
.gateway-options {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 1rem;
}/* === Gateway Icons with Boxicons === */
.gateway {
  flex: 1;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: center;
}
.gateway:hover {
  transform: translateY(-3px);
  background: #eef2ff;
  border-color: #3b82f6;
}
.gateway-icon {
  font-size: 2.2rem;
  margin-bottom: 6px;
  display: block;
}

/* === Brand Colors === */
.gateway.razorpay .gateway-icon {
  color: #0c5394; /* Razorpay blue */
}
.gateway.paypal .gateway-icon {
  color: #00457c; /* PayPal navy */
}
.gateway.stripe .gateway-icon {
  color: #635bff; /* Stripe purple */
}
.gateway span {
  display: block;
  font-weight: 600;
  color: #111827;
}

/* === Close Button === */
.close-btn {
  width: 100%;
  margin-top: 10px;
}


</style>
